import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'stdtfDark',
    themes: {
      stdtfDark: {
        dark: true,
        colors: {
          background:         '#080c17',
          surface:            '#0f1525',
          'surface-variant':  '#1a2238',
          primary:            '#00d4ff',
          secondary:          '#0ea5e9',
          error:              '#ef4444',
          warning:            '#f59e0b',
          success:            '#10b981',
          'on-background':    '#e2e8f0',
          'on-surface':       '#cbd5e1',
          'on-primary':       '#001219',
        },
      },
    },
  },
})
